import React from 'react';
import { Routes, Route } from 'react-router-dom';

import { useAuth } from '../hooks/auth';
import Home from '../pages/Home';
import Users from '../pages/Users';
import UsersDetails from '../pages/UsersDetails';
import Login from '../pages/Login';
import Categories from '../pages/Categories';
import CategoriesInternal from '../pages/CategoriesInternal';

const RoutesComponent: React.FC = () => {
  const { signed } = useAuth();
  return (
    <>
      {
            signed && (
              <Routes>
                <Route path="/dashboard" element={<Home/>} />
                <Route path="/" element={<Home/>} />
                <Route path="/users" element={<Users/>} />
                <Route path="/categories/internal" element={<CategoriesInternal/>} />
                <Route path="/categories" element={<Categories/>} />
                <Route path="/users/:id/:name/:email/:avatar" element={<UsersDetails/>} />
              </Routes>
            )
        }
      {
            !signed && (
              <Routes>
                <Route path="/" element={<Login/>} />
              </Routes>
            )
        }
    </>
  );
};

export default RoutesComponent;
